import { ILangOption } from "../components";

export const mockedLanguages: ILangOption[] = [
  {
    id: "1",
    label: "Deutsch",
    icon: "FlagDeIcon",
  },
  {
    id: "2",
    label: "Francais",
    icon: "FlagFrIcon",
  },
];
